import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3924ab4a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3924ab4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3924ab4a')) {
      api.createRecord('3924ab4a', component.options)
    } else {
      api.reload('3924ab4a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3924ab4a&scoped=true", function () {
      api.rerender('3924ab4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mySelect/index.vue"
export default component.exports